<ng-container *ngIf="isBrochure">
  <ion-card
    (click)="openPdfPrompt()"
    [ngClass]="cardClass"
    class="ion-text-center ion-no-margin"
  >
    <ng-container *ngTemplateOutlet="cardContent"></ng-container>
  </ion-card>
</ng-container>

<ng-container *ngIf="isExternalLink">
  <ion-card
    (click)="checkNetwork(cardRoute)"
    [ngClass]="cardClass"
    class="ion-text-center ion-no-margin"
    target="_blank"
  >
    <ng-container *ngTemplateOutlet="cardContent"></ng-container>
  </ion-card
></ng-container>

<ng-container *ngIf="isInternalNavigation">
  <ion-card
    [routerLink]="cardRoute"
    [ngClass]="cardClass"
    class="ion-text-center ion-no-margin"
  >
    <ng-container *ngTemplateOutlet="cardContent"></ng-container>
  </ion-card
></ng-container>

<ng-template #cardContent>
    <div class="card-body">
        <img
            *ngIf="cardImage"
            [src]="(cardImage | file: cardType | async)"
            class="ion-text-center" />
        <h3
            *ngIf="cardTitle"
            [innerHtml]="cardTitle"
            class="ion-title ion-no-margin"
        ></h3>
        <h4
            *ngIf="cardSubtitle"
            [innerHtml]="cardSubtitle"
            class="ion-subtitle ion-no-margin"
        ></h4>
    </div>
</ng-template>
